"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(".o-depoimentos__slider");
        if (!initSlider) return;

        const swiper = new Swiper(".o-depoimentos__slider", {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,

            navigation: {
                nextEl: ".o-depoimentos__arrow--next",
                prevEl: ".o-depoimentos__arrow--prev",
            },
        });
    });
}
